<template>
  <div class="admin-login-container">
    <div class="login-box">
      <div class="logo-area">
        <div class="logo-icon">
          <img src="/logo.png" alt="Logo" class="logo-img">
        </div>
        <h1>后台管理系统</h1>
        <p>IM即时通讯系统</p>
      </div>
      
      <el-form :model="form" ref="formRef" :rules="rules" label-width="0" class="login-form">
        <el-form-item prop="username" class="form-item">
          <el-input 
            v-model="form.username" 
            placeholder="请输入用户名" 
            :disabled="isSubmitting"
            class="wechat-input">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password" class="form-item">
          <el-input 
            type="password" 
            v-model="form.password" 
            placeholder="请输入密码" 
            :disabled="isSubmitting"
            class="wechat-input">
          </el-input>
        </el-form-item>
        
        <el-form-item class="form-item">
          <el-button 
            type="primary" 
            @click="handleLogin" 
            :loading="isSubmitting"
            class="login-btn">
            登录
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="version-info">版本 3.0.0</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      isSubmitting: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.isSubmitting = true
          try {
            const response = await this.$http({
              url: '/admin/login',
              method: 'post',
              data: this.form
            })
            
            localStorage.setItem('adminToken', response.token)
            this.$router.push('/im_admin')
          } catch (error) {
            this.$message.error(error.message || '登录失败')
          } finally {
            this.isSubmitting = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.admin-login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.logo-area {
  text-align: center;
  margin-bottom: 30px;
}

.logo-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-area h1 {
  font-size: 20px;
  color: #000;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.logo-area p {
  font-size: 14px;
  color: #888;
  margin: 0;
}

.login-form {
  .form-item {
    margin-bottom: 0;
  }
  
  .wechat-input {
    width: 100%;
    
    .el-input__inner {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border: none;
      border-bottom: 1px solid #e5e5e5;
      border-radius: 0;
      padding: 0;
      font-size: 16px;
      color: #333;
      background: transparent;
      
      &:focus {
        border-color: #07c160;
        box-shadow: none;
      }
      
      &::placeholder {
        color: #ccc;
        font-size: 16px;
      }
    }
  }
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  background: #07c160;
  border-color: #07c160;
  border-radius: 22px;
  
  &:hover, &:focus {
    background: #06ae56;
    border-color: #06ae56;
  }
}

.version-info {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #ccc;
}
</style>